module.exports = __webpack_public_path__ + "media/stylesheets/images/section_img_3-7eff8ed9c3b1bdff0a3ece75a4bbf52d.jpg";